// Input components
import Checkbox from '@/components/checkbox.vue'
import FileInput from '@/components/forms/inputs/file-input.vue'
import FileSelect from '@/components/forms/inputs/file-select.vue'
import JsonInput from '@/components/forms/inputs/json-input.vue'
import MultiSelect from '@/components/forms/inputs/multiselect.vue'
import SelectInput from '@/components/forms/inputs/select-input.vue'
import TextInput from '@/components/forms/inputs/text-input.vue'

// UI components
import ButtonLoading from '@/components/button-loading.vue'
import Card from '@/components/cards/BaseCard.vue'
import Divider from '@/components/divider.vue'
import InputError from '@/components/forms/inputs/input-error.vue'
import Modal from '@/components/modals/BaseModal.vue'
import Alert from '@/components/Alert.vue'
import Navbar from '@/components/navbar/Navbar.vue'
import StorageCounter from '@/components/profile/StorageCounter.vue'
import PrimaryButton from '@/components/forms/buttons/primary-button.vue'
import MarkdownRenderer from '@/components/MarkdownRenderer.vue'
import BaseTable from '@/components/table/BaseTable.vue'

// Navigation components
import SubTabs from '@/components/subtabs.vue'
import Tabs from '@/components/Tabs.vue'

// Modal components
import FilePreviewModal from '@/components/modals/file-preview-modal.vue'
import JsonPreviewModal from '@/components/modals/json-preview-modal.vue'

// Toast components
import Toast from '@/components/toast.vue';

export function useLayoutComponents() {
  return {
    ButtonLoading,
    Card,
    Checkbox,
    Alert,
    Divider,
    FileInput,
    FilePreviewModal,
    StorageCounter,
    FileSelect,
    InputError,
    JsonInput,
    JsonPreviewModal,
    Modal,
    MultiSelect,
    Navbar,
    PrimaryButton,
    SelectInput,
    SubTabs,
    Tabs,
    TextInput,
    Toast,
    MarkdownRenderer,
    BaseTable,
  }
}